
      var _g, _g2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLockUnlockNp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 241,
  height: 240,
  viewBox: "0 0 241 240",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 54)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 108,
  width: 96,
  height: 60,
  rx: 6,
  transform: "rotate(-90 30 108)",
  stroke: "var(--theme-black, #000000)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 94,
  r: 4,
  fill: "var(--theme-primary, #810ea9)"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(142 54)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 108,
  width: 96,
  height: 60,
  rx: 6,
  transform: "rotate(-90 30 108)",
  stroke: "var(--theme-black, #000000)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 94,
  r: 4,
  fill: "var(--theme-primary, #810ea9)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 7,
  strokeLinecap: "round",
  d: "M108 122h28"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "m136 108 16 14-16 14z"
})));

      const __svgRaw = "<svg width=\"241\" height=\"240\" viewBox=\"0 0 241 240\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g transform=\"translate(0, 54) scale(1)\">\r\n    <rect x=\"30\" y=\"108\" width=\"96\" height=\"60\" rx=\"6\" transform=\"rotate(-90 30 108)\" stroke=\"var(--theme-black, #000000)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <circle cx=\"60\" cy=\"94\" r=\"4\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  </g>\r\n  <g transform=\"translate(142, 54) scale(1)\">\r\n    <rect x=\"30\" y=\"108\" width=\"96\" height=\"60\" rx=\"6\" transform=\"rotate(-90 30 108)\" stroke=\"var(--theme-black, #000000)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <circle cx=\"60\" cy=\"94\" r=\"4\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  </g>\r\n  <line x1=\"108\" y1=\"122\" x2=\"136\" y2=\"122\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"7\" stroke-linecap=\"round\"/>\r\n  <polygon points=\"136,108 152,122 136,136\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/lock-unlock-np.55aefd88742eef807b9c6d0bd3604d34.svg"),
        {
          React: SvgLockUnlockNp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      